import { colors } from "theme/palette";

import Stack from "components/Stack";
import Text from "components/Text";

import ESignAssigneeModificationTable from "entities/Memo/components/ESignAssigneeModificationTable";

// Used for anchoring
export const ID = "e_sign_roles_section";

const ESignRoles = () => {
  return (
    <Stack id={ID}>
      <Text
        variant="h3"
        fontWeight={700}
        sx={{
          borderBottom: `1px solid ${colors.gray100}`,
          marginBottom: 2,
        }}
      >
        E-sign roles
      </Text>
      <ESignAssigneeModificationTable />
    </Stack>
  );
};

export default ESignRoles;
